// css =>
import "../../BaseStructure.css";
import Styled from "./ShoppingCard.module.css";

// componenets =>
import Header from "../../Components/header/header.comp";
import MenuBar from "../../Components/menuBar/menuBar.comp";
import ProductBox from "../../Components/productBox/productBox.comp";
import SpinnerBar from "../../Components/spinnerBar/spinnerBar.comp";
import LocationShow from "../../Components/locationShow/locationShow.comp";
import FirstMenuBar from "../../Components/firstMenuBar/firstMenuBar.comp";
import MobileMenuBar from "../../Components/mobileMenuBar/mobileMenuBar.comp";

// react =>
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// API =>
import backEnd from "../../services/Api";

// Type =>
import { CART } from "./ShoppingCardType";

// utils =>
import { formatPrice } from "../../utils/ChangePriceFormat";
import { LocalCSRFReceiver } from "../../utils/GetLocalCSRF";

// hooks =>
import { useUserStore } from "../../hooks/useUserStore";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";

function ShoppingCard() {

    const navigate = useNavigate();
    const { showMessage } = useMessage();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [shoppingCardItems, setShoppingCardItems] = useState<CART | null>(null);

    useEffect(() => {
        document.title = "سبد خرید | ویدوک";

        setIsLoading(true);
        backEnd.get("shopping-cart/").then(( result ) => {
            setShoppingCardItems(result.data);

            setIsLoading(false);
        }).catch(( error ) => {
            if (error.status === 401 || error.status === 403) {
                useUserStore.getState().setUser(null);
                localStorage.removeItem("user-storage");

                showMessage("error", "لطفا ابتدا وارد حساب کاربری خود شوید یا اگر ندارید یکی ایجاد کنید!");
                navigate("/sign-in");
                return
            }
            setIsLoading(false);
            showMessage("error", "خطایی رخ داد!");
        });
    }, []);

    const handleCreateOrder = async () => {
        setIsLoading(true);

        try {
            const csrf = await LocalCSRFReceiver();
            const response = await backEnd.get(`users/profile-get/${ useUserStore.getState().user?.id }/`);

            await backEnd.post(
                "orders/create-order/",
                {
                    orderer: useUserStore.getState().user?.id,
                    products: shoppingCardItems?.id,
                    receiving_province: response.data.receiving_province,
                    receiving_city: response.data.receiving_city,
                    receiving_address: response.data.address,
                    receiving_postal_code: response.data.postal_code,
                    receiving_house_number: response.data.house_number,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": csrf,
                    }
                }
            )

            setIsLoading(false);
            showMessage("success", "سفارش شما با موفقیت ثبت شد");
            navigate("/order-show");

        } catch (error: any) {
                const status = error.response?.status;
                let errorMessage: string = "خطایی رخ داد!";

                switch(status) {
                    case 400:
                        errorMessage = "لطفا اطلاعات محل دریافت سفارش خود را ثبت کنید!";
                        navigate("/edit-profile");
                        break;
                    case 401:
                    case 403:
                        useUserStore.getState().setUser(null);
                        localStorage.removeItem("user-storage");

                        errorMessage = "لطفا ابتدا وارد حساب کاربری خود شوید یا یکی ایجاد کنید!";
                        navigate("/sign-in");
                        break;
                    case 404:
                        errorMessage = "سبد خرید یافت نشد!"
                        break;
                    case 409:
                        errorMessage = "سبد خرید شما خالی است!"
                        break;
                    case 500:
                        errorMessage = "خطای سرور. لطفا دوباره تلاش کنید!"
                        break;
                    default:
                        errorMessage = "خطایی رخ داد. لطفا دوباره تلاش کنید!"
                }

                setIsLoading(false);
                showMessage("error", errorMessage);
        }
    }

    return(
        <>
            <Header />
            <MobileMenuBar key={ 0 } isAuthenticated />
            <LocationShow key={ 0 } pathName="حساب کاربری من" />
            <FirstMenuBar />

            {
                isLoading ? (
                    <div className="row">
                        <br />
                        <div className="col-12 SpinnerBarFrame">
                            <SpinnerBar />
                        </div>
                    </div>
                ) : !shoppingCardItems || shoppingCardItems.items?.length === 0 ? (
                    <p className="EmptyText">سبد خرید خالی است</p>
                ) : (
                shoppingCardItems.items.map((item: any) => (
                    <ProductBox
                        key={ item.id }
                        productKey={ item.id }
                        productThumbnail={ item.product.thumbnail }
                        productCode={ item.product.id }
                        productColor={ item.item_color }
                        productVariant={ item.item_variant }
                        productName={ item.product.full_name }
                        productQuantity={ item.quantity }
                        productPrice={ formatPrice(item.total_price) }
                    />
                ))
            )}

            <div className="row" data-aos="fade-up">
                <div className="col-12">
                    <button id={ Styled.ProductPriceButton } disabled>
                        <h3>مبلغ نهایی: { formatPrice(shoppingCardItems?.cart_total_price ?? 0) }</h3>
                    </button>
                </div>

                <div className="col-12">
                    <button id={ Styled.ProductPriceDoneButton } onClick={ handleCreateOrder }>
                        <h2>تکمیل پرداخت و خرید</h2>
                    </button>
                </div>
            </div>

            <br /><br />

            <MenuBar />

            <br /><br /><br />
        </>
    );
}

export default ShoppingCard;
